<template>
  <div class="about"></div>
</template>

<script>
export default {
  mounted() {
    if (this.$session.exists()) this.$router.push({ name: "Home" });
    else this.$router.replace({ name: "Login" });
  }
};
</script>
